export default [
    {
        date: 'Feb 1, 2019',
        venue: 'Ronnie Scotts',
        city: 'London',
        tickets: 'http://www.bokante.com/tour'
    },
    {
        date: 'Feb 2, 2019',
        venue: 'Glasgow Celtcic Connections/Queen Margaret Union',
        city: 'Glasgow',
        tickets: 'http://www.bokante.com/tour'
    },
    {
        date: 'Feb 8, 2019',
        venue: 'Ground UP Music Fest',
        city: 'Miami, FL',
        tickets: 'http://groundupmusicfestival.com'
    },
    {
        date: 'Feb 15, 2019',
        venue: 'Revolution Live',
        city: 'Ft. Lauderdale',
        tickets: 'https://www.facebook.com/events/262625311103762/'
    },
    {
        date: 'Feb 16, 2019',
        venue: 'Branquility Music Festival',
        city: 'Safety Harbor, FL',
        tickets: 'https://www.facebook.com/events/267320023969968/'
    },
    {
        date: 'Feb 17, 2019',
        venue: 'Vinyl Music Hall',
        city: 'Pensacola, FL',
        tickets: 'https://www.facebook.com/events/258558388139631/'
    },
    {
        date: 'Feb 21, 2019',
        venue: 'The Tumblefoot Brewery',
        city: 'Sante Fe, NM',
        tickets: 'https://www.facebook.com/events/662027387546661/'
    },
    {
        date: 'Feb 22, 2019',
        venue: 'Taos Messa Mothership Brewing ',
        city: 'Taos, NM',
        tickets: 'https://www.facebook.com/events/288180018561914/'
    },
    {
        date: 'Feb 24, 2019',
        venue: 'The Cooperage',
        city: 'Albuquerque, NM',
        tickets: 'https://www.facebook.com/events/321876925321271/'
    },
    {
        date: 'Feb 26, 2019',
        venue: 'Agave',
        city: 'Avon, CO',
        tickets: 'https://www.facebook.com/events/287246955271251/'
    },
    {
        date: 'Feb 27, 2019',
        venue: 'Public House',
        city: 'Crested Butte, CO',
        tickets: 'https://www.facebook.com/events/1098171667010153/'
    },
    {
        date: 'Feb 28, 2019',
        venue: 'OTP',
        city: 'Steamboat Springs, CO',
        tickets: 'https://www.facebook.com/events/275628496451252/'
    },
    {
        date: 'Mar 1, 2019',
        venue: 'Caribou Room',
        city: 'Nederland, CO',
        tickets: 'https://www.thecaribouroom.com/calendar/'
    },
    {
        date: 'Mar 8, 2019',
        venue: 'Ponte Vedra Music Hall',
        city: 'Ponte Vedra, FL',
        tickets: 'https://www.facebook.com/events/2156385828022387/'
    },
    {
        date: 'Mar 14, 2019',
        venue: 'Iron Cow',
        city: 'Orlando, FL',
        tickets: 'https://www.facebook.com/events/376563752916269/'
    },
    {
        date: 'Mar 15, 2019',
        venue: 'Swamptown Get Down',
        city: 'WayCross, GA',
        tickets: 'https://www.facebook.com/swamptowngetdown/'
    },
    {
        date: 'Mar 16, 2019',
        venue: 'Ashley Street Station',
        city: 'Valdosta, GA',
        tickets: null
    },
    {
        date: 'Mar 20, 2019',
        venue: 'Guanabanas',
        city: 'Jupiter, FL',
        tickets: null
    },
    {
        date: 'Mar 21, 2019',
        venue: 'Heartwood',
        city: 'Gainsville, FL',
        tickets: null
    },
    {
        date: 'Mar 24, 2019',
        venue: 'Crazy Uncle Mike’s',
        city: 'Boca Raton, FL',
        tickets: 'https://www.facebook.com/events/348747042631883/'
    },
    {
        date: 'Mar 27, 2019',
        venue: 'Bob Weird After Party',
        city: 'Jacksonvile, FL ',
        tickets: null
    },
    {
        date: 'Mar 30, 2019',
        venue: 'Hollywood ArtsPark',
        city: 'Hollywood, FL',
        tickets: 'https://www.songkick.com/concerts/36585869-spam-allstars-at-hollywood-artspark?utm_source=11593&utm_medium=partner&utm_campaign=widget&utm_content=299511'
    },
    {
        date: 'Apr 6, 2019',
        venue: 'Wynwood Yard',
        city: 'Miami, FL',
        tickets: null
    },
    {
        date: 'Apr 11, 2019',
        venue: 'Quasimodo',
        city: 'Berlin, Germany',
        tickets: null
    },
    {
        date: 'Apr 12, 2019',
        venue: 'International Festival of Carthage',
        city: 'Tunis, Tunisia',
        tickets: null
    },
    {
        date: 'Apr 13, 2019',
        venue: 'Ronnie Scotts',
        city: 'London, UK',
        tickets: null
    },
    {
        date: 'Apr 15, 2019',
        venue: 'DEXTER',
        city: 'Odense, Denmark',
        tickets: null
    },
    {
        date: 'Apr 16, 2019',
        venue: 'Fasching Club',
        city: 'Stockholm, Sweden',
        tickets: 'https://www.facebook.com/events/284664905582172/'
    },
    {
        date: 'Apr 20, 2019',
        venue: 'Jazz Eastern',
        city: 'Terni, Italy',
        tickets: null
    },
    {
        date: 'Apr 21, 2019',
        venue: 'Jazz Eastern',
        city: 'Terni, Italy',
        tickets: null
    },
    {
        date: 'Apr 25, 2019',
        venue: 'JazzFest',
        city: 'New Orleans, LA',
        tickets: null
    },
    {
        date: 'Apr 26, 2019',
        venue: 'JazzFest',
        city: 'New Orleans, LA',
        tickets: null
    },
    {
        date: 'Apr 27, 2019',
        venue: 'JazzFest',
        city: 'New Orleans, LA',
        tickets: null
    },
    {
        date: 'Apr 28, 2019',
        venue: 'JazzFest',
        city: 'New Orleans, LA',
        tickets: null
    },
    {
        date: 'Apr 29, 2019',
        venue: 'JazzFest',
        city: 'New Orleans, LA',
        tickets: null
    },
    {
        date: 'May 1, 2019',
        venue: 'JazzFest',
        city: 'New Orleans, LA',
        tickets: null
    },
    {
        date: 'May 2, 2019',
        venue: 'Jazzfest',
        city: 'New Orleans, LA',
        tickets: null
    },
    {
        date: 'May 8, 2019',
        venue: 'Brooklyn Bowl',
        city: 'Brooklyn, NY',
        tickets: null
    },
    {
        date: 'May 18, 2019',
        venue: 'Orange Blossom Jamboree',
        city: 'Brooksville, FL',
        tickets: null
    },
    {
        date: 'May 22, 2019',
        venue: 'The Pour House',
        city: 'Charleston, SC',
        tickets: null
    },
    {
        date: 'May 24, 2019',
        venue: 'Asheville Music Hall',
        city: 'Asheville, NC',
        tickets: null
    },
    {
        date: 'May 25, 2019',
        venue: 'Rooster Walk Music & Arts Fest',
        city: 'Axton, VA',
        tickets: null
    },
    {
        date: 'May 26, 2019',
        venue: 'Rooster Walk Music & Arts Fest',
        city: 'Axton, VA',
        tickets: null
    },
    {
        date: 'Jun 25, 2019',
        venue: 'Rochester Int. Jazz Fest',
        city: 'Rochester, NY',
        tickets: null
    },
    {
        date: 'Jun 26, 2019',
        venue: 'Rochester Int. Jazz Fest',
        city: 'Rochester, NY',
        tickets: null
    },
    {
        date: 'Sep 11, 2019',
        venue: 'YarmonyGrass',
        city: 'Boulder, CO',
        tickets: null
    }
];
